import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginPageComponent } from "../../pages/login-page/login-page.component";

@Component({
  selector: 'app-login-layout',
  imports: [LoginPageComponent],
  templateUrl: './login-layout.component.html',
  styleUrl: './login-layout.component.scss'
})
export class LoginLayoutComponent implements OnInit, OnDestroy {

  constructor(private renderer: Renderer2) {}

  classes = [
    'login-page',
    'bg-body-secondary',
    'app-loaded'
  ]

  ngOnInit(): void {
    // Add class to the body tag
    this.classes.forEach((className) => {
      this.renderer.addClass(document.body, className);
    });
  }

  ngOnDestroy(): void {
    // Clean up by removing the class
    this.classes.forEach((className) => {
      this.renderer.removeClass(document.body, className);
    });
  }
}